import React from 'react'
import { Box } from "@mui/material"

import { AppOfficesBlock } from "@components/DataBlocks/index"
import { AppButtonIcon } from "@components/@base"
import { officeModalData } from "@signals"
import AppMoreCount from "./MoreCount"


// compact: the first office on one line and "+N" for the rest (they open in "Show all")
export default function AppOfficesBlockContainer({ rows, compact = false }) {
	if (compact) return <Box sx={{ display: 'flex', alignItems: 'center' }}>
		{!!rows?.[0] && <AppOfficesBlock name={rows[0].name} type={rows[0].type} country={rows[0].country}/>}
		<AppMoreCount count={(rows?.length || 0) - 1} onClick={() => officeModalData.value = rows}/>
	</Box>

	return <Box>
		<Box sx={{ display: "flex", alignItems: "start", justifyContent: "start", flexDirection: "column" }}>
			{rows?.map(({ name, type, country }, idx) => {
				if (idx < 10) {
					return <AppOfficesBlock
						name={name}
						type={type}
						country={country}
						key={`${name}-${idx}`}
					/>
				}
			})}
			{rows?.length >= 10 && <AppButtonIcon
				onClick={() => officeModalData.value = rows}
				iconWeight="regular"
				icon="plus"
				tooltip={`Show all`}
				sx={{ color: "info.main", pl: .2 }}
			/>}
		</Box>
	</Box>

}